import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setBlockCalendarEnabledState', function (choice) {
    var optionState = getStore().currentState;
    optionState.blockCalendarEnabled = choice;
});
//# sourceMappingURL=setBlockCalendarEnabledState.js.map